const TEXT_FIELD_LEFT_CONTENT_HORIZONTAL_SPACING = {
  small: 4,
  default: 6,
  large: 10,
  xlarge: 12
};

export { TEXT_FIELD_LEFT_CONTENT_HORIZONTAL_SPACING };
//# sourceMappingURL=constants.mjs.map
